// @flow

import React from 'react';
import { formatedDurationByMilliseconds } from 'services/format/formatDuration';

type Props = {
  className?: string,
  dateToCompare: number,
  onTimeUp: () => void,
}

type State = {
  currentTime: number,
}

const pattern = 'D[d : ]HH[h : ]mm[m : ]ss[s]';

export default class Counter extends React.Component<Props, State> {
  interval: ?IntervalID

  constructor(props: Props) {
    super(props);
    this.state = { currentTime: (new Date()).getTime() };
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      this.updateTimer();
    }, 1000);
  }

  componentDidUpdate() {
    const { currentTime } = this.state;
    const { dateToCompare, onTimeUp } = this.props;
    const duration = dateToCompare - currentTime;
    if (duration <= 0 && onTimeUp) onTimeUp();
  }

  componentWillUnmount() {
    this.interval && clearInterval(this.interval);
  }

  updateTimer() {
    this.setState({
      currentTime: (new Date()).getTime(),
    });
  }

  render() {
    const { currentTime } = this.state;
    const { dateToCompare, className } = this.props;
    const duration = dateToCompare > currentTime ? dateToCompare - currentTime : 0;
    return (
      <div className={className}>
        {formatedDurationByMilliseconds(duration, pattern)}
      </div>
    );
  }
}
